import colors from "../../../../Constants/colors";

export const accordioStyles = {
  // boxShadow: `0px 0px 10px ${colors.secondaryBlue}`,
  backgroundColor: colors.extremeWhite,
  color: colors.extremeBlack,
  borderBottom: `2px solid ${colors.primaryBlue}`,
  mb: 2,
  borderRadius: "4px",
};
export const textfieldLayout = {
  backgroundColor: colors.extremeWhite,
  borderRadius: "5px",
  // boxShadow: "0px 4px 12px var(--secondaryBlue)",
  "& .MuiInputBase-input": {
    color: colors.extremeBlack, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: colors.extremeBlack,
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  border: `1px solid ${colors.primaryBlue}`,
};
